import Exclamation from './exclamation.png'

export const Images = {
  Exclamation
};
